import {
  FETCH_CATEGORIES_REQUEST,
  FETCH_CATEGORIES_SUCCESS,
  FETCH_CATEGORIES_FAILURE,
  ADD_CATEGORY_REQUEST,
  ADD_CATEGORY_SUCCESS,
  ADD_CATEGORY_FAILURE,
  UPDATE_CATEGORY_REQUEST,
  UPDATE_CATEGORY_SUCCESS,
  UPDATE_CATEGORY_FAILURE,
  DELETE_CATEGORY_REQUEST,
  DELETE_CATEGORY_SUCCESS,
  DELETE_CATEGORY_FAILURE,
  SET_CATEGORY_EDIT,
  CLEAR_CATEGORY_EDIT,
} from '../../../../types/masters/styles/category/categoryTypes';

const initialState = {
  list: [],
  loading: false,
  error: null,
  editingCategory: null,
};

const categoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CATEGORIES_REQUEST:
    case ADD_CATEGORY_REQUEST:
    case UPDATE_CATEGORY_REQUEST:
    case DELETE_CATEGORY_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_CATEGORIES_SUCCESS:
      return { ...state, loading: false, list: action.payload, error: null };
    case ADD_CATEGORY_SUCCESS:
    case UPDATE_CATEGORY_SUCCESS:
    case DELETE_CATEGORY_SUCCESS:
      return { ...state, loading: false, error: null };
    case FETCH_CATEGORIES_FAILURE:
    case ADD_CATEGORY_FAILURE:
    case UPDATE_CATEGORY_FAILURE:
    case DELETE_CATEGORY_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case SET_CATEGORY_EDIT:
      return { ...state, editingCategory: action.payload };
    case CLEAR_CATEGORY_EDIT:
      return { ...state, editingCategory: null };
    default:
      return state;
  }
};

export default categoryReducer; 